import { ChipInput, ChipInputProps } from './generic'

export type StringChipInputProps = Omit<ChipInputProps<string>, 'renderLabel' | 'makeValue'>
export const StringChipInput = ({ ...rest }: StringChipInputProps): React.ReactElement => {
    return (
        <ChipInput<string>
            renderLabel={(v: string): React.ReactNode => {
                return v
            }}
            makeValue={(input): string => {
                return input
            }}
            {...rest}
        />
    )
}
